import React from "react";
import {
  SafetyCertificateOutlined,
  TeamOutlined,
  DeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import type { TabKey } from "../pages/AdminConsole/constants";

export interface RouteConfig {
  path: string;
  tab: TabKey;
  label: string;
  icon: React.ReactNode;
}

export const ADMIN_ROUTES: RouteConfig[] = [
  {
    path: "/users",
    tab: "users",
    label: "Users",
    icon: <UserOutlined />,
  },
  {
    path: "/admins",
    tab: "admins",
    label: "Admins",
    icon: <TeamOutlined />,
  },
  {
    path: "/domains",
    tab: "domains",
    label: "Domains",
    icon: <SafetyCertificateOutlined />,
  },
  {
    path: "/roles",
    tab: "roles",
    label: "Roles",
    icon: <SafetyCertificateOutlined />,
  },
  {
    path: "/trash",
    tab: "trash",
    label: "Trash",
    icon: <DeleteOutlined />,
  },
];

export const DEFAULT_PATH = "/admins";
